import { ContextMenuMESFProvider } from "@dexteel/mesf-core";
import { CategoriesProvider } from "../categories/context/CategoriesContext";
import { ConfigurationDelayCodeProvider } from "../codes/context/ConfigurationDelayCodeContext";
import { DelaysReportPage } from "./DelaysReportPage";
import { DelaysReportProvider } from "./context/DelaysReportContext";
type Props = {
	asset: "caster" | "eaf";
};
const DelaysReport = ({ asset }: Props) => {
	return (
		<ContextMenuMESFProvider>
			<ConfigurationDelayCodeProvider>
				<CategoriesProvider>
					<DelaysReportProvider>
						<DelaysReportPage asset={asset} />
					</DelaysReportProvider>
				</CategoriesProvider>
			</ConfigurationDelayCodeProvider>
		</ContextMenuMESFProvider>
	);
};
export default DelaysReport;
